import React from "react";
import PropTypes from "prop-types";
import { getFunName } from "../helpers";

class StorePicker extends React.Component {
    myInput = React.createRef();

    static propTypes = {
        history: PropTypes.object
    };

    // this is what you want to run when clicking the button
    goToStore = event => {
        // 1. Stop the form from submitting
        // that's in part because we are not submitting this form to a server
        // everything is staying in the browser for now
        event.preventDefault();

        // 2. get the text from that input
        // you don't do this the usua; javascript or jQuery way because...
        // "the Golden Rule in React is 'Don't Touch The DOM'"
        // (though he said there are some use cases for touching the DOM)
        // so 2 ways to handle this, one is with refs, which was done here (below)
        // the other way is syncing the values of the form inputs with state, which we do in other places in this app
        const storeName = this.myInput.value.value;  // see the  ref={this.myInput}  below

        // 3. Change the page to /store/whatever-they-entered
        this.props.history.push(`./store/${storeName}`);
    };
    render() {
        return (
            // see the onSubmit refrences the goToStore of this component
            <form className="store-selector" onSubmit={this.goToStore}>
                <h2>Please Enter A Store</h2>
                <input
                    type="text"
                    ref={this.myInput}  // other ways you might see this, see ref notes below
                    required
                    placeholder="Store Name"
                    defaultValue={getFunName()}
                />
                <button type="submit">Visit Store →</button>
            </form>
        );
    }
}

export default StorePicker;

// NOTES

// refs

// other ways you might see this: ref={this.myInput}
// ref="myInput"   then use this.ref.myInput   ...but this is deprecated
// or, another way is a "function ref":
// ref={(myInput) => this.myInput = myInput}  ...this was the way for longest time, but confusing
// so above is the right way:
// create the ref:
// myInput = React.createRef();
// use the ref:
// ref={this.myInput}

// events

// events are like they are in regaar Javascipt except they are inline
// rather that external JS referencing a class or ID

// could do this:

// handleClick() {
//     alert ("Hey!")
// }
//
// <button onClick={this.handleClick}>Visit Store →</button>

// detail on above:
// the reason it is this {this.handleClick} and not this {this.handleClick()}
// is that the () means "run on page load" and in this case we do not want that

// but we don't do the above because we want goToStore to run on form submit not on button click
// so this:
// <form className="store-selector" onSubmit={this.goToStore}>


// WEBPACK FOOTER //
// ./src/components/StorePicker.js